import fetch from "lib/fetch";
import type { AuthData, ResetPasswordInterface } from "types/authentication";

type AuthResponse = { data: AuthData };
type GenericResponse = { data: unknown };
type TokenResponse = { data: { username: string; token: string } };

export const getCsrfTokenRequest = () =>
    fetch.get<GenericResponse>("authentication/csrf-cookie");

export const loginRequest = (username: string, password: string) =>
    fetch.post<AuthResponse>("authentication/login", { username, password });

export const logoutRequest = () =>
    fetch.post<GenericResponse>("authentication/logout");

export const selectRoleRequest = (roleId: string) =>
    fetch.post<AuthResponse>(`authentication/select_role/${roleId}`);

export const freshRequest = () =>
    fetch.get<AuthResponse>("authentication/fresh");

export const forgotPasswordRequest = (username: string) =>
    fetch.post<GenericResponse>("authentication/forgot_password", { username });

export const checkResetTokenRequest = (token: string) =>
    fetch.post<TokenResponse>("authentication/check_reset_token", { token });

export const resetPasswordRequest = (values: ResetPasswordInterface) =>
    fetch.post<GenericResponse>("authentication/reset_password", values);

export const validateEmailRequest = (token: string) =>
    fetch.post<TokenResponse>("authentication/validate_email", { token });

export const resendEmailValidationRequest = (username: string) =>
    fetch.post<TokenResponse>("authentication/resend_email_validation", { username });
